import i18n from "@/i18n";
import common from "@assets/js/common";

const state = {
    loading: false,
    monitorData: [],
    currentBook: "",
    lastSelectedBook: "",
};

const actions = {
    /**
     * Process alert data
     * @param   {[type]}  commit  [commit description]
     * @param   {[type]}  data    [data description]
     *
     * @return  {[type]}          [return description]
     */
    processLargeExposure({ commit, state }, data) {
        if (
            state.currentBook != state.lastSelectedBook ||
            parseInt(Date.now() / 1000) % 5 == 0
        ) {
            let result = [];
            for (let item in data) {
                if (data[item].books[0] == state.currentBook) {
                    let temp = data[item];
                    // temp["symbol"] = temp["symbol"].split("_")[0];
                    temp["trigger_time"] =
                        common.convertUnixtimeToDatetimeString(temp.timestamp);
                    result.push(temp);
                }
            }
            state.lastSelectedBook = state.currentBook;
            commit("UPDATE_MONITOR_DATA", result);
        }
    },
};

const mutations = {
    /**
     * Update monitor data
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_MONITOR_DATA(state, data) {
        state.monitorData = data;
    },
    /**
     * Update alert data
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_ALERT_DATA(state, data) {
        state.alertData = data;
    },
    /**
     * Update loading
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_LOADING(state, data) {
        state.loading = data;
    },
    UPDATE_CURRENT_BOOK(state, data) {
        state.currentBook = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
